<mc-popover trigger="click" position="bottom-right" arrow fit="small">
  <mc-avatar slot="trigger"
             clickable
             hiddentooltip
             fit="small"
             appearance="color-3"
             [attr.imagesrc]="userService.avatarSrc()"
             [attr.initials]="userService.initials()"></mc-avatar>
  <div class="mds-flex mds-flex-column" style="padding: 12px;">
    <span><strong>{{ userService.name() }}</strong></span>
    <span class="mds-neutral--weak__text-color">{{ userService.email() }}</span>
    <span class="mds-text--small-medium" style="text-transform: capitalize;">{{ userService.role() }}</span>
    <hr />
    <mc-button label="Sign out"
               appearance="neutral"
               fit="small"
               fullwidth
               trailingicon="door-arrow-right"
               (click)="userService.logout()"></mc-button>
  </div>
</mc-popover>
